import Link from 'next/link';
import { Badge, Button } from '@general';
import { Inbox } from '@public';

import styles from './messageIcon.module.scss';

interface MessageIconProps {
	unreadNumber?: number;
}

export const MessageIcon = ({ unreadNumber: unreadMessages = 0 }: MessageIconProps) => {
	const hasMessages = unreadMessages > 0;

	return (
		<Link href={'/inbox'}>
			<Button
				customStyles={styles.messageIconButton}
				ariaLabel="Notification"
				data-testid="messageIcon"
			>
				<Badge
					label={
						hasMessages ? (
							<div className={styles.circle}>
								<p className={styles.circle__number} data-testid="unreadMessagesNumber">
									{unreadMessages}
								</p>
							</div>
						) : (
							''
						)
					}
					customStyles={styles.badge}
				>
					<Inbox customStyles={styles.icon} />
				</Badge>
			</Button>
		</Link>
	);
};
